import React from 'react'
import { useLocation } from 'react-router-dom'

import AuthForm from '../../components/auth/form'
import { useAuth } from '../../context/auth'
import { AUTH_REDIRECT_PATH_KEY } from '../../lib/signIn'
import './styles.scss'

const LoginPage = () => {
  const { signin, signInMicrosoft, user } = useAuth()
  const location = useLocation()
  const from = location.state?.from?.pathname || '/dashboard'

  if (user) {
    const redirectPath = localStorage.getItem(AUTH_REDIRECT_PATH_KEY) ?? from
    localStorage.removeItem(AUTH_REDIRECT_PATH_KEY)
    window.location.replace(redirectPath)
  }

  return (
    <div className='login-page'>
      <AuthForm
        title='Sign in or create your account'
        onGoogleSignIn={signin}
        onMicrosoftSignIn={signInMicrosoft}
      />
    </div>
  )
}

export default LoginPage
